import * as React from "react";
import { PropertyGallery as SharedUiPropertyGallery } from "@shared-ui/lodging-property-details";
import { RefTarget } from "@shared-ui/ref-context";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";

const WrappedPropertyGallery = PropertyBexApiWrapper(SharedUiPropertyGallery);

export const PropertyGallery: React.FC<ComponentProps> = ({ context }) => (
  <RefTarget name="Overview" tag="section">
    <WrappedPropertyGallery context={context} />
  </RefTarget>
);

export default PropertyGallery;
